import React from "react";
import { Route } from "react-router-dom";

import {
  MEDIA_LIBRARY_URL,
  ROOT_URL,
} from "cortex/ui/src/fleet/constant/mediaLibrary";
import MediaTable from "cortex/ui/src/fleet/view/media-library/component/MediaTable";
import DeployPage from "cortex/ui/src/fleet/view/strategy/component/Deploy";
import DeployList from "cortex/ui/src/fleet/view/strategy/component/DeployList";
import StrategyDetailPage from "cortex/ui/src/fleet/view/strategy/component/Detail";
import ScheduleDeployList from "cortex/ui/src/fleet/view/strategy/component/ScheduleDeployList";
import StrategyList from "cortex/ui/src/fleet/view/strategy/component/StrategyList";

function renderStrategyRoutes() {
  return [
    <Route
      exact
      key="strategy-list"
      path={ROOT_URL}
      render={(routeProps) => {
        return (
          <StrategyList
            {...routeProps}
            archived={false}
            viewUrl={`${ROOT_URL}/`}
          />
        );
      }}
    />,
    <Route
      exact
      key="strategy-list-archived"
      path={`${ROOT_URL}/archived`}
      render={(routeProps) => {
        return (
          <StrategyList
            {...routeProps}
            archived={true}
            viewUrl={`${ROOT_URL}/`}
          />
        );
      }}
    />,
    <Route
      component={DeployPage}
      exact
      key="strategy-deploy"
      path={`${ROOT_URL}/deploy`}
    />,
    <Route
      component={DeployList}
      exact
      key="strategy-deployments"
      path={`${ROOT_URL}/deployments`}
    />,
    <Route
      component={StrategyDetailPage}
      exact
      key="strategy-edit"
      path={`${ROOT_URL}/:id/:viewType(clone|edit)`}
    />,
    <Route
      component={MediaTable}
      exact
      key="strategy-media-library"
      path={[MEDIA_LIBRARY_URL, `${MEDIA_LIBRARY_URL}/folders/:id`]}
    />,
    <Route
      component={StrategyDetailPage}
      exact
      key="strategy-new"
      path={`${ROOT_URL}/:viewType(create)`}
    />,
    <Route
      component={ScheduleDeployList}
      exact
      key="strategy-scheduled-deployments"
      path={`${ROOT_URL}/scheduled`}
    />,
  ];
}

export { MEDIA_LIBRARY_URL, renderStrategyRoutes };
